"use strict";
/**
 * @module valueSetRoute
 * @description Baasic Value Set Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Value Set Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var _1 = require("./");
var contracts_1 = require("../../core/contracts");
var ValueSetRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ValueSetRoute, _super);
    function ValueSetRoute(appOptions, valueSetItemRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.valueSetItemRoute = valueSetItemRoute;
        _this.findRoute = 'value-sets/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'value-sets/{setName}/{?embed,fields}';
        _this.createRoute = 'value-sets';
        _this.updateRoute = 'value-sets/{id}';
        _this.deleteRoute = 'value-sets/{id}';
        return _this;
    }
    Object.defineProperty(ValueSetRoute.prototype, "items", {
        get: function () {
            return this.valueSetItemRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find value set route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify value set resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain value set subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the value set property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example valueSetRoute.find(options);
     **/
    ValueSetRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get value set route which must be expanded with the name of the previously created value set resource in the system.
     * @method
     * @param setName Value Set name.
     * @param options Query resource options object.
     * @example valueSetRoute.get(setName, options);
     **/
    ValueSetRoute.prototype.get = function (setName, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, setName, options, 'setName');
    };
    /**
     * Parses create value set route; this URI template does not expose any additional options.
     * @method
     * @example valueSetRoute.create();
     **/
    ValueSetRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update value set route.
     * @method
     * @param data Value set object used to update specified value set resource.
     * @example valueSetRoute.update(data);
     */
    ValueSetRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete value set route.
     * @method
     * @param data A value set object used to delete specified value set resource.
     * @example valueSetRoute.delete(data);
     */
    ValueSetRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    ValueSetRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ValueSetItemRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.ValueSetItemRoute !== "undefined" && _1.ValueSetItemRoute) === "function" ? _b : Object])
    ], ValueSetRoute);
    return ValueSetRoute;
}(common_1.BaseRoute));
exports.ValueSetRoute = ValueSetRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 
